__turbopack_context__.v({
  "ManualLayout": "GY_4CG_ManualLayout",
  "ManualLayout--Wide": "GY_4CG_ManualLayout--Wide",
  "ManualLayout__Container": "GY_4CG_ManualLayout__Container",
  "ManualLayout__Header": "GY_4CG_ManualLayout__Header",
  "ManualLayout__Lightbox": "GY_4CG_ManualLayout__Lightbox",
  "ManualLayout__Main": "GY_4CG_ManualLayout__Main",
  "ManualLayout__Nav": "GY_4CG_ManualLayout__Nav",
  "ManualLayout__Pagination": "GY_4CG_ManualLayout__Pagination",
});
